var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6, _linearGradient5, _path7, _linearGradient6, _path8, _linearGradient7, _path9, _path10, _linearGradient8, _path11, _linearGradient9, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 28.449,
    y1: 56.498,
    x2: 64.729,
    y2: 56.498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_0_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.074 56.498h35.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M64.104 53.396V4.863H23.171l.028 51.365"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M64.104 53.395H26.305A3.114 3.114 0 0023.2 56.5a3.114 3.114 0 003.105 3.105h37.799v-6.21z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 26.07,
    y1: 10.766,
    x2: 20.271,
    y2: 10.766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.896 10.766h4.549"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 26.07,
    y1: 18.033,
    x2: 20.271,
    y2: 18.033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.896 18.033h4.549"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 26.07,
    y1: 25.3,
    x2: 20.271,
    y2: 25.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.896 25.3h4.549"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 26.07,
    y1: 32.567,
    x2: 20.271,
    y2: 32.567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.896 32.567h4.549"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 26.07,
    y1: 39.834,
    x2: 20.271,
    y2: 39.834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.896 39.834h4.549"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 26.07,
    y1: 47.101,
    x2: 20.271,
    y2: 47.101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.896 47.101h4.549"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M33.477 11.735h22.29v6.488h-22.29z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 35.355,
    y1: 37.998,
    x2: 53.721,
    y2: 37.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.542 30.614h1.594c.42 0 .818.155 1.133.432 1.078.957 3.625 3.441 4.977 6.617.974 2.291.839 4.209.848 4.339.025.462-.281 2.66-2.858 3.03-1.548.222-3.764.336-5.703.348h.009c-1.939-.013-4.154-.126-5.703-.348-2.576-.369-2.883-2.568-2.858-3.03.008-.13-.126-2.048.848-4.339 1.351-3.176 3.898-5.661 4.977-6.617a1.71 1.71 0 011.133-.432h1.603z",
    fill: "none",
    stroke: "url(#SVGID_7_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b",
    gradientUnits: "userSpaceOnUse",
    x1: 39.487,
    y1: 28.037,
    x2: 49.582,
    y2: 28.037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.541 30.652h3.828a.555.555 0 00.488-.291l2.032-3.763a.554.554 0 00-.071-.631c-.307-.349-.941-.79-2.029-.383-1.652.618-1.506 1.157-3.551.315-1.427-.588-2.449.022-2.936.444a.552.552 0 00-.119.691l1.874 3.334a.555.555 0 00.484.284z",
    fill: "none",
    stroke: "url(#SVGID_8_6193e05e9a3b83e3e1df14648b81f2315d7e32f696353b016904a43deb8f698b)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M46.11 36.885s-.278-1.607-1.607-1.607c-1.33 0-1.687 1.607-1.687 1.607l3.453 2.618M42.974 39.503s.278 1.607 1.607 1.607c1.33 0 1.687-1.607 1.687-1.607M44.542 33.908v1.37M44.542 41.11v1.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentJournal);
export default __webpack_public_path__ + "static/media/paymentJournal.b4c96216d149038eee5f963637c1b48b.svg";
export { ForwardRef as ReactComponent };